import { useMemo } from 'react'
import { SettingsTeamModule } from '@core/modules/team/team.module'
import { unifiedTeamFilterModule } from '@core/modules/team/team.filters'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import SearchFilterSection from '@components/searchFilterSection/SearchFilterSection'

const TeamPageHeader = () => {
    const { data } = SettingsTeamModule.useStore()
    const members = useMemo(() => Object.values(data), [data])

    const {
        search,
        filterConfig,
        data: filteredMembers,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
        activeFilters,
    } = useUnifiedFilter({
        filterModule: unifiedTeamFilterModule,
        data: members,
    })

    return (
        <SearchFilterSection
            allItems={members}
            filteredItems={filteredMembers}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            getFilterOptions={getFilterOptions}
            filterConfig={filterConfig}
            searchValue={search}
            activeFilters={activeFilters}
            searchPlaceholder="Search user"
            itemLabel="users"
            onFilterReset={handleFilterReset}
        />
    )
}

export default TeamPageHeader
